export default "__VITE_ASSET__C9eQ_bSa__"